<template>
  <div class="modal-container" ref="modalContainer">
    <div class="form-content-body">

      <div class="row">
        <div class="col-md-12 text-center modal-header px-5 align-items-center">
          <div class="header-container row justify-content-between w-100">
            <span class="empty-space" />

            <h3 class="text-center">{{FORM_LABELS.INVOICE_DETAILS}}</h3>
            <button class="close close-btn" @click="$emit('close')">
              <img src="../../../assets/images/icon-close.svg">
            </button>
          </div>
        </div>
      </div>
      <div class="row mx-3 mt-5 d-md-flex d-none ">
        <div class="col-md-3 font-weight-bold">
          <span class="required-field">{{FORM_LABELS.DESCRIPTION}}</span>
        </div>
        <div class="col-md-2 font-weight-bold">
          <header-with-tooltip
              :tooltipText="FORM_LABELS.GL_ACCOUNT_TOOLTIP">
            <span class="mr-1 required-field">{{FORM_LABELS.GL_ACCOUNT}}</span>
          </header-with-tooltip>
        </div>
        <div class="col-md-3 font-weight-bold">
          <header-with-tooltip
              :tooltipText="FORM_LABELS.COST_CENTER_TOOLTIP">
            <span class="mr-1" :class="costCenterIsRequired ? 'required-field':null">{{FORM_LABELS.COST_CENTER}}</span>
          </header-with-tooltip>
        </div>
        <div class="col-md-2 font-weight-bold">
          <header-with-tooltip
              :tooltipText="FORM_LABELS.WBS_TOOLTIP">
            <span class="mr-1">{{FORM_LABELS.WBS}}</span>
          </header-with-tooltip>
          <div>{{FORM_LABELS.WBS_WHERE_APPLICABLE}}</div>

        </div>
        <div class="col-md-2 font-weight-bold">
          <span class="required-field">{{FORM_LABELS.AMOUNT}}</span>
        </div>
      </div>

      <div v-for="(invoice, key) in invoiceItems" :key="key">
        <div class="row mx-3 pt-3">
          <div class="col-md-3 pt-md-0 pt-2 col-12">
            <div class="d-md-none d-block required-field">{{FORM_LABELS.DESCRIPTION}}</div>
            <input
                class="form-control"
                v-model="invoice.itemDescription"
                :name="'itemDescription-'+key"
                v-validate="'required|max:35'"
                data-vv-validate-on="input"
                autocomplete="nope" />

            <show-errors :for-item="'itemDescription-'+key" :form-errors="errors" :field-name="FORM_LABELS.DESCRIPTION" :max-length="35" />
          </div>

          <div class="col-md-2 pt-md-0 pt-2 col-12">
            <div class="d-md-none d-block">
              <header-with-tooltip
                  :tooltipText="FORM_LABELS.GL_ACCOUNT_TOOLTIP">
                <span class="mr-1 required-field">{{FORM_LABELS.GL_ACCOUNT}}</span>
              </header-with-tooltip>
            </div>
            <input class="form-control"
                   v-model="invoice.glAccount"
                   :name="'glAccount-'+key"
                   v-validate.continues="{ required: true, regex: /^([0-9]+)$/, min:6, max:6 }"
                   autocomplete="nope"
                  />
            <show-errors :for-item="'glAccount-'+key" :form-errors="errors" :field-name="FORM_LABELS.GL_ACCOUNT" :max-length="6" min-length="6" />

          </div>

          <div class="col-md-3 pt-md-0 pt-2  col-12">
            <div class="d-md-none d-block">
              <header-with-tooltip
                  :tooltipText="FORM_LABELS.COST_CENTER_TOOLTIP">
                <span class="mr-1" :class="costCenterIsRequired ? 'required-field':null">{{FORM_LABELS.COST_CENTER}}</span>
              </header-with-tooltip>
            </div>
            <span class="row no-gutters">
                          <input class="form-control col-12 pl-1"
                                 v-model="invoice.costCenter"
                                 :name="'costCenter-'+key"
                                 v-validate="costCenterValidation(key)"
                                 data-vv-validate-on="input"
                                 autocomplete="nope"
                          />
            </span>

            <show-errors :for-item="'costCenter-'+key"
                         :form-errors="errors"
                         :field-name="FORM_LABELS.COST_CENTER"
                         :min-length="10"
                         :max-length="10"
                         :cost-center-prefix=invoiceDetails.costCenterPrefix />

          </div>

          <div class="col-md-2 pt-md-0 pt-2 col-12">
            <div class="d-md-none d-block">
            <header-with-tooltip
                :tooltipText="FORM_LABELS.WBS_TOOLTIP">
              <span class="mr-1">{{FORM_LABELS.WBS}}</span>
            </header-with-tooltip>
            <div>{{FORM_LABELS.WBS_WHERE_APPLICABLE}}</div>
            </div>
            <input
                class="form-control"
                v-model="invoice.wbsElement"
                autocomplete="nope"
                v-validate="'max:24'"
                data-vv-validate-on="input"
                :name="'wbsElement-'+key" />

            <show-errors :for-item="'wbsElement-'+key" :form-errors="errors" :field-name="FORM_LABELS.WBS" :max-length="24" />

          </div>

          <div class="col-md-2 pt-md-0 pt-2 col-12">
            <div class="d-md-none d-block required-field">{{FORM_LABELS.AMOUNT}}</div>
            <div class="row no-gutters">
              <input class="form-control col-4 text-center" disabled="true" :placeholder="currency"  />
              <input class="form-control col-6 pl-1"
                     :name="'amount-'+key"
                     v-model="invoice.itemTotal"
                     v-validate.continues="{ required: true, max:maximumAmountCharLength, regex: CONSTANTS.POSITIVE_OR_NEGATIVE_WITH_DECIMAL_AND_COMMAS }"
                     @blur="formatItemTotalAmount($event, key)"
                     data-vv-validate-on="input"
                     autocomplete="nope"
              />
              <div class="col-2 my-auto d-block">
                <img
                    class="float-right delete-row"
                    title="Delete line item"
                    src="../../../assets/images/action_delete.svg"
                    @click="deleteRow(key)"
                />
              </div>
            </div>
            <show-errors :for-item="'amount-'+key" :form-errors="errors" :field-name="FORM_LABELS.AMOUNT" :max-length="maximumAmountCharLength" />
            <validate-amount-decimals :amount="invoice.itemTotal" :currency-text="currency" @onValidationError="setItemTotalInvalid" />
          </div>
          <hr v-if="key < invoiceItems.length - 1" class="d-md-none d-block w-100 mt-5"/>
        </div>
      </div>

      <div class="ml-4 pl-1 mt-4" v-if="addingInvoicesIsAllowed">
        <span class="solution-link" @click="addMoreInvoiceDetails"><span v-if="invoiceItems.length === 0">{{FORM_LABELS.ADD_AN_INVOICE}}</span><span v-else>{{FORM_LABELS.ADD_ANOTHER_INVOICE}}</span></span>
      </div>

      <div class="row text-right no-gutters mr-4 pr-1 pb-4">
        <div class="col-12 float-right pt-5 font-weight-bold">{{FORM_LABELS.NET_AMOUNT}}: {{ currency }} {{totalInvoiceAmount}}</div>
        <div v-if="isNetAmountNegative && showNegativeNetAmountError" class="text-danger float-right input-error-text col-12">
          Net amount cannot be negative.
          <div>
            Please correct or update the line items.
          </div>
        </div>

        <div class="col-12 float-right ml-3 modal-buttons">
          <button class="btn-container flat-btn gray-btn close-btn btn mr-2" @click="$emit('close')">Cancel</button>
          <span>
            <button class="btn-container btn flat-btn submit-btn" @click="addItems" v-if="!isExistingDataPresent">{{FORM_LABELS.ADD_ITEMS}}</button>
            <button class="btn-container btn flat-btn submit-btn" @click="addItems" v-else>{{FORM_LABELS.UPDATE_ITEMS}}</button>
          </span>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import HeaderWithTooltip from "@/components/HeaderWithTooltip";
import cloneDeep from "lodash.clonedeep"
import CONSTANTS from "@/store/constants";
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";
import {Validator} from "vee-validate";


export default {
  name: "AddMultipleInvoiceDetails",
  components: {HeaderWithTooltip},
  mixins: [PaymentFormsMixin],
  props: ['invoiceDetails'],
  data() {
    return {
      costCenterPrefix: '',
      currency: '',
      showCostCenterErrorMsg:null,
      maxAllowedInvoicesReached: false,
      isExistingDataPresent: false,
      isItemTotalInvalid: false,
      showNegativeNetAmountError: false,
    }
  },
  mounted() {
    this.invoiceItems = this.invoiceDetails.invoiceItems && this.invoiceDetails.invoiceItems.length > 0
        ? JSON.parse(JSON.stringify(this.invoiceDetails.invoiceItems)) : this.invoiceItems
    if(this.invoiceItems && this.invoiceItems.length > 0) {
      this.isExistingDataPresent = true
    }
    this.currency = this.getTextValue(this.adminDataList.currencyList, this.invoiceDetails.currency)
    this.injectCostCenterValidator()
  },
  computed: {
    isNetAmountNegative() {
      return this.getFloatValue(this.totalInvoiceAmount) < 0
    },
    costCenterIsRequired() {
      let costCenterRequired = false
      this.invoiceItems.forEach(item => {
        if(this.glAccountStartsWithSixOrSeven(item.glAccount)) {
          costCenterRequired = true
        }
      })
      return costCenterRequired
    },
    totalInvoiceAmount() {
      let totalInvoiceAmount = 0
      if(this.invoiceItems && this.invoiceItems.length > 0) {
        this.invoiceItems.forEach(invoice => {
          if(this.getFloatValue(invoice.itemTotal) > 0 || this.getFloatValue(invoice.itemTotal) < 0) {
            totalInvoiceAmount= totalInvoiceAmount + this.getFloatValue(invoice.itemTotal)
          }
        })
      }
      let allowedDecimals = this.currency ? this.adminDataList.currencyList.find(currency => currency.text === this.currency).decimal : 2
      return this.updateAmount(totalInvoiceAmount, allowedDecimals)
    },
    addingInvoicesIsAllowed() {
      return this.invoiceItems.length < CONSTANTS.MAX_ALLOWED_INVOICE_ITEMS
    }
  },
  methods: {
    glAccountStartsWithSixOrSeven(value) {
      //Cost center is mandatory only if GL Account starts with either 6 or 7, otherwise it is not.
      return value.indexOf("6") === 0 || value.indexOf("7") === 0
    },
    costCenterValidation(row) {
      let invoice = this.invoiceItems[row]
      if(invoice && invoice.glAccount && invoice.glAccount.length > 0 && (this.glAccountStartsWithSixOrSeven(invoice.glAccount))) {
        return { required: true, costCenterRule: true, numeric: true, min: 10, max: 10 }
      } else {
        return { required: false, costCenterRule: true, max: 10 }
      }
    },
    injectCostCenterValidator() {
      let that = this
      Validator.extend('costCenterRule',  {
        validate(value) {
          if(value.length > 3) {
            return that.invoiceDetails.costCenterPrefix===value.substring(0,4)
          } else {
            return true
          }
        }
      });
    },
    formatItemTotalAmount(event, key) {
      let allowedDecimals = 0

      allowedDecimals = this.adminDataList.currencyList.find(currency => currency.text === this.currency).decimal

      let targetText = event.target.value
      if(targetText && targetText.length > 0 && (this.isValidNumber(targetText))) {
        this.invoiceItems[key].itemTotal = this.updateAmount(targetText, allowedDecimals)
      }

    },
    setItemTotalInvalid(value) {
      this.isItemTotalInvalid = value
    },
    addMoreInvoiceDetails() {
      this.$validator.validateAll().then((result) => {
        if(result && !this.isItemTotalInvalid) {
          //maintaining itemId as index from this array
          this.invoiceItems.push({itemId: `${this.invoiceItems.length}`, itemDescription: '', glAccount: '', costCenter: '', wbsElement: '', itemTotal: ''})
        }
      })
    },
    deleteRow(index) {
      this.isItemTotalInvalid = false
        let invoiceItemsList = cloneDeep(this.invoiceItems)
        invoiceItemsList.splice(index, 1)
        this.invoiceItems = cloneDeep(invoiceItemsList)
    },
    addItems() {
      this.$validator.validateAll().then((result) => {
        if(result && !this.isItemTotalInvalid && !this.isNetAmountNegative) {
          this.$parent.$emit('invoicesAdded', { invoiceDetails: {
              invoiceItems: this.invoiceItems,
              netAmount: this.totalInvoiceAmount,
          }})
          this.$parent.$emit('closed')
        } else if(this.isNetAmountNegative) {
          this.showNegativeNetAmountError = true
        }
      })
    },
  }

}
</script>

<style scoped>
.modal-container {
  overflow-y: auto !important;
  height: 100%;
  overflow-x: hidden;
}

.delete-row {
  height: 20px;
  width: 100%;
  cursor: pointer;
}


.modal-buttons {
  padding-top: 6%;
  padding-right: 1%;
}

</style>